import PasswordStrength from '@fnando/password_strength/app/assets/javascripts/password_strength';

import { CheckCreator } from 'lib/utils/formValidation/formValidation';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
const isPasswordStrong: CheckCreator = (username: string) => (password: string) => {
  const strength = PasswordStrength.test(username, password);

  return strength.isStrong();
};

export default isPasswordStrong;
